import { deepMemoized } from './helpers';
import { wrappedAnalytics } from './setConfiguration';
import { setProps } from './setProps';
let previousTrackingProps;
export function sendSelfPromotion(selfPromotionProps) {
  const {
    type,
    customObject
  } = selfPromotionProps;
  const eventType = 'impression' in selfPromotionProps ? `${type}.impression` : `${type}.click`;
  const optionalProps = selfPromotionProps.impression ?? selfPromotionProps.click;
  const formattedAdsProps = deepMemoized({
    onsitead_type: type === 'publisher' ? 'Publisher' : 'Self Promotion',
    customObject,
    ...Object.entries(optionalProps || {}).reduce((acc, [key, value]) => {
      acc[`onsitead_${key}`] = value;
      return acc;
    }, {})
  });
  if (!previousTrackingProps || formattedAdsProps !== previousTrackingProps) {
    previousTrackingProps = formattedAdsProps;
    if (customObject && Object.keys(customObject).length) {
      setProps(customObject, {
        events: [eventType]
      });
    }
    wrappedAnalytics.sendEvent(eventType, formattedAdsProps);
  }
}